// font awesome
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook,
  faArrowLeft,
  faAsterisk,
  faBars,
  faBan,
  faBook,
  faCalendar,
  faCalendarWeek,
  faCalendarDay,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircleNotch,
  faClipboard,
  faClone,
  faCodeBranch,
  faDownload,
  faEdit,
  faEnvelope,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faHistory,
  faKey,
  faMinusSquare,
  faPlus,
  faRedo,
  faSearch,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUser,
  faUserAstronaut,
  faUserEdit,
  faPencilAlt,
  faEye,
  faSignOutAlt,
  faSignInAlt,
  faSms,
  faFileImport,
  faReply,
  faSave,
  faServer,
  faLock,
  faFilter
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

export function configureFontAwesome () {
  // set up the font awesome library
  library.add(
    faAddressBook,
    faArrowLeft,
    faAsterisk,
    faBars,
    faBook,
    faBan,
    faCalendar,
    faCalendarWeek,
    faCalendarDay,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronRight,
    faChevronUp,
    faCircleNotch,
    faClipboard,
    faClone,
    faCodeBranch,
    faDownload,
    faFileImport,
    faEdit,
    faEnvelope,
    faExchangeAlt,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faFileImport,
    faHistory,
    faKey,
    faMinusSquare,
    faPlus,
    faRedo,
    faSearch,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrashAlt,
    faUser,
    faUserAstronaut,
    faUserEdit,
    faPencilAlt,
    faEye,
    faSignOutAlt,
    faSignInAlt,
    faSms,
    faReply,
    faSave,
    faServer,
    faLock,
    faFilter,
    faWhatsapp
  )
  Vue.component('font-awesome-icon', FontAwesomeIcon)
  Vue.component('font-awesome-layers', FontAwesomeLayers)
  Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
}
